import { useCallback, useMemo } from 'react';
import { useFullLesson } from '../lessons';
import { useFullTrack } from '../tracks';
import { getVideoPlayerComponent, useVideoPlayerConfig } from '.';
export const useVideo = ({
  contentId,
  lessonId,
  trackId,
  language
}) => {
  const {
    lesson
  } = useFullLesson(Number(lessonId), language);
  const {
    track
  } = useFullTrack(Number(trackId), language);
  const getLessonVideo = useCallback(() => {
    if (!lesson) return undefined;
    if (contentId) return lesson.content.find(content => content.id === Number(contentId));
    const firstVideoContent = lesson.content.find(content => content.reference);
    if (!firstVideoContent) return undefined;
    return firstVideoContent;
  }, [contentId, lesson]);
  const getTrackVideo = useCallback(() => {
    if (track) {
      let firstLessonVideoContent = undefined;
      for (const trackLesson of track.lessons) {
        firstLessonVideoContent = trackLesson.content.find(content => content.reference);
        if (firstLessonVideoContent) break;
      }
      if (track.introVideo) return track.introVideo;else if (firstLessonVideoContent) return firstLessonVideoContent;else return undefined;
    }
    return undefined;
  }, [track]);
  const video = useMemo(() => lessonId ? getLessonVideo() : getTrackVideo(), [getLessonVideo, getTrackVideo, lessonId]);
  const {
    autoPlay,
    playSpeed
  } = useVideoPlayerConfig();
  const {
    reference: videoId,
    referenceType,
    hubId: creatorHubId,
    duration: videoDuration
  } = video || {};
  const videoType = referenceType;
  return {
    PlayerComponent: getVideoPlayerComponent(videoType),
    videoType,
    videoId,
    autoPlay,
    playSpeed,
    creatorHubId,
    videoDuration
  };
};